<template>
  <section>
    <CommonHeader />
    <section class="tw-container tw-mx-auto tw-py-14">
      <h3 class="tw-text-3xl md:tw-text-4xl tw-text-center tw-text-bold">Media Kit</h3>
      <section class="tw-flex tw-flex-col tw-gap-7">
        <div v-for="(group, type) in images" :key="type">
          <h6 class="tw-text-center tw-text-primary tw-font-bold tw-my-5 tw-text-xl md:tw-text-2xl lg:tw-text-3xl tw-text-bold"  v-html="type"> </h6>
          <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-5">
            <div class="tw-card tw-shadow-xl" v-for="({ url, filename, theme }, index) in group" :key="index">
              <figure :class="theme === 'dark' ? 'tw-bg-accent' : 'tw-bg-white'" class="tw-h-24 tw-px-4">
                <NuxtImg class="tw-h-full tw-mx-auto" :src="url" :title="filename" :alt="filename" />
              </figure>
              <div class="tw-card-body">
                <div class="tw-card-actions tw-justify-end tw-gap-2">
                  <template v-if="/\.svg$/i.test(filename)">
                    <a
                      :href="url"
                      :title="filename"
                      @click.prevent="onImageDownload(url, filename)"
                      class="tw-flex tw-items-center tw-text-xs tw-gap-1"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-w-4 tw-h-4 tw-inline-block">
                        <title>cloud-download-outline</title>
                        <path
                          d="M6.5 20Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.68 7.35 7.38 5.73 9.07 4.1 11 4.1 11.83 4.1 12.41 4.69 13 5.28 13 6.1V12.15L14.6 10.6L16 12L12 16L8 12L9.4 10.6L11 12.15V6.1Q9.1 6.45 8.05 7.94 7 9.43 7 11H6.5Q5.05 11 4.03 12.03 3 13.05 3 14.5 3 15.95 4.03 17 5.05 18 6.5 18H18.5Q19.55 18 20.27 17.27 21 16.55 21 15.5 21 14.45 20.27 13.73 19.55 13 18.5 13H17V11Q17 9.8 16.45 8.76 15.9 7.73 15 7V4.68Q16.85 5.55 17.93 7.26 19 9 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20M12 11.05Z"
                        />
                      </svg>
                      SVG
                    </a>
                    <a
                      :href="url"
                      :title="filename?.replace(/\.svg$/i, '.png') || filename"
                      @click.prevent="onPngDownload(url, filename?.replace(/\.svg$/i, '.png') || filename)"
                      class="tw-flex tw-items-center tw-text-xs tw-gap-1"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-w-4 tw-h-4 tw-inline-block">
                        <title>download</title>
                        <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                      </svg>
                      PNG
                    </a>
                  </template>
                  <a
                    v-else
                    :href="url"
                    :title="filename"
                    @click.prevent="onImageDownload(url, filename)"
                    class="tw-flex tw-items-center tw-text-xs tw-gap-1"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-w-4 tw-h-4 tw-inline-block">
                      <title>download</title>
                      <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                    </svg>
                    PNG
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>
<script lang="ts">
  import { Canvg, presets } from 'canvg'

  const preset = presets.offscreen()

  export default {
    name: 'MediaKit.Index',
    data() {
      return {
        images: {
          latest: [
            {
              url: '/res/img/header-logo-black.svg',
              theme: 'light',
              filename: 'logo-legend-black.svg',
            },
            {
              url: '/res/img/header-logo-white.svg',
              theme: 'dark',
              filename: 'logo-legend-white.svg',
            },
            {
              url: '/res/img/header-logo-black-wrap.svg',
              theme: 'light',
              filename: 'logo-legend-black-alt.svg',
            },
            {
              url: '/res/img/header-logo-white-wrap.svg',
              theme: 'dark',
              filename: 'logo-legend-white-alt.svg',
            },
          ],
          legacy: [
            {
              url: '/res/img/logo-gold.svg',
              theme: 'light',
              filename: 'legacy-logo-legend-gold.svg',
            },
            {
              url: '/res/img/logo-black.svg',
              theme: 'light',
              filename: 'legacy-logo-legend-black.svg',
            },
            {
              url: `/res/img/logo.svg`,
              theme: 'light',
              filename: 'logo-legend.svg',
            },
            {
              url: `/res/img/logo-legend-001.png`,
              theme: 'light',
              filename: 'legacy-logo-legend-001.png',
            },
            {
              url: `/res/img/logo-legend-002.png`,
              theme: 'light',
              filename: 'legacy-logo-legend-002.png',
            },
            {
              url: `/res/img/logo-legend-003.png`,
              theme: 'light',
              filename: 'legacy-logo-legend-003.png',
            },
          ],
        },
      }
    },
    methods: {
      async fetchImageData(src = '') {
        const req = new Request(src)
        const resp = await fetch(req)
        const blob = await resp.blob()
        const objectURL = URL.createObjectURL(blob)

        return objectURL
      },
      async getImageSize(src = ''): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {
          const $img = document.createElement('img')
          $img.onload = function () {
            resolve(this as HTMLImageElement)
          }
          $img.onerror = reject
          $img.src = src
        })
      },
      async toPng(data: any) {
        const { width, height, svg } = data

        // @ts-ignore
        const canvas = new OffscreenCanvas(width, height)
        const ctx = canvas.getContext('2d')
        if (!ctx) {
          throw new Error('context 2d not found.')
        }
        // @ts-ignore
        const v = await Canvg.from(ctx, svg, preset)

        v.resize(width, height, 'xMidYMid meet')

        await v.render()

        const blob = await canvas.convertToBlob()
        const pngUrl = URL.createObjectURL(blob)

        return pngUrl
      },
      handleDownload(url = '', filename = '') {
        const $el = document.createElement('a')
        $el.href = url
        $el.download = filename
        $el.click()
        URL.revokeObjectURL(url)
      },
      async onImageDownload(url = '', filename = '') {
        const objectURL = await this.fetchImageData(url)
        this.handleDownload(objectURL, filename)
      },
      async onPngDownload(url = '', filename = '') {
        const image = await this.getImageSize(url)
        const data = window.prompt('Please input a size (width,height):', `${image.width},${image.height}`)
        if (data) {
          const [width, height] = data.split(/\W+/)
          const objectURL = await this.toPng({ width, height, svg: url })
          this.handleDownload(objectURL, filename)
        } else {
          // abort download
        }
      },
    },
    created() {},
  }
  
</script>
